<template>
  <ModalDefault header="y"
                modal_id="openTicketModal"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_157')"
                :footer="!chat.lead_check.ticket && chat.new_ticket.department_id > 0 ||
                         (chat.new_ticket.department_id > 0 && chat.wallet_check.id >= 0) ||
                         (me.data.role_key > 0 && chat.new_ticket.operator_id > 0 && chat.new_ticket.operator_id === null && chat.new_ticket.department_id > 0 && chat.wallet_check.id < 0)"
                icon="bx bx-chat mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div v-if="tickets.ticket_step === 0" class="row pt-1 px-2">
        <div class="col-12 text-center">
          {{ getTranslations('expression_36') }}
        </div>
      </div>
      <div v-if="tickets.ticket_step === 1 && chat.lead_check.ticket && chat.lead_check.ticket.department_id" class="row pt-1 px-2">
        <div class="col-12">
          <div class="alert alert-warning rounded-0 mb-2 " role="alert">
            <span class="pl-1">{{ getTranslations('expression_807') }}</span>
          </div>
        </div>
        <div class="col-12 pt-2 pb-4">
          <div class="px-3 d-flex justify-content-between py-3 shadow-sm" :style="($mq === 'mobile' || $mq === 'tablet') ? 'min-height: 110px;' : ''">
            <div>
              <div class="container_list pl-0" style="cursor: default!important;">
                <div class="avatar_content pl-1 pr-4">
                  <div style="width: 60px; height: 60px;"
                       class="pl-2 avatar">
                    <img style="min-width: 60px;
                                 min-height: 60px;
                                 z-index: 9;
                                 display: flex;
                                 border-radius: 50%;
                                 align-items: center;
                                 justify-content: center;"
                         class="avatar-img mt-1"
                         :src="chat.lead_check.avatar_url ? chat.lead_check.avatar_url : no_pic"/>
                    <span style="min-width: 60px;
                                 min-height: 60px;
                                 margin-left: -60px;
                                 z-index: 8;
                                 display: flex;
                                 border-radius: 50%;
                                 align-items: center;
                                 justify-content: center;
                                 background-color: #eee;"
                          class="avatar-img mt-1">
                      <i class="bx bx-loader-alt bx-spin" style="font-size: 2rem; color: #bfbfbf;"></i>
                    </span>
                  </div>
                </div>
                <div class="contact_area pr-4">
                  <div class="contact_title_area">
                    <div class="contact_title_line">
                      <div class="contact_title_line_area">
                        <span class="contact_title d-inline-block visible-true">
                          <span style="font-weight: 500; font-size: 1rem; color: #353535; letter-spacing: .02rem;">
                            {{ (chat.lead_check.name ? chat.lead_check.name : '---') | truncate(20) }}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="text_preview_content">
                    <div class="text_preview_area">
                      <span class="text_preview_zone">
                        <span class="contact_title d-inline-block visible-true">
                          <span style="font-family: 'Product Sans Light Regular';white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex-grow: 1; letter-spacing: .02rem; font-weight: 100; font-size: .8rem; color: #7c7c7c">
                            {{ chat.lead_check.phone_hidden ? chat.lead_check.phone_hidden : '---' }}
                          </span>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="row text_preview_content">
                    <div class="col-md-6" :class="($mq === 'mobile' || $mq === 'tablet') ? 'pb-1' : ''">
                      <div class="text_preview_area">
                        <span class="text_preview_zone">
                          <span class="contact_title d-inline-block visible-true">
                            <span style="display: flex; align-items: center; font-weight: 400; font-size: .7rem; color: #7c7c7c">
                              <i style="font-size: 1rem;" :class="getChannelObject('id', chat.lead_check.channel_id).type ? getChannelObject('id', chat.lead_check.channel_id).type.icon : 'bx bx-mobile'" class="mr-1"></i>
                              {{ getChannelObject('id', chat.lead_check.channel_id).name | truncate(20) }}
                            </span>
                          </span>
                        </span>
                      </div>
                    </div>
                    <div class="col-md-6" :class="($mq === 'mobile' || $mq === 'tablet') ? 'pt-0 pb-2 pl-2' : ''">
                      <div class="text_small_list">
                        <span>
                          <div class="text_preview_flag">
                            <span style="display: flex; align-items: center; font-weight: 400; font-size: .7rem; color: #7c7c7c">
                              <i class="bx bx-time mr-1"></i>
                              {{ chat.lead_check.created ? chat.lead_check.created : '---' }}
                            </span>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-light border-top shadow-sm py-3" :class="($mq === 'mobile' || $mq === 'tablet') ? 'd-block px-3' : 'd-flex justify-content-around px-0'" >
            <div class="" :class="($mq === 'mobile' || $mq === 'tablet') ? 'col-md-12' : ''">
              <small class="title-header">
                {{ getTranslations('expression_12') }}
              </small>
              <div>
                {{ getDepartmentObject('id', chat.lead_check.ticket.department_id).name ? getDepartmentObject('id', chat.lead_check.ticket.department_id).name : '---' }}
              </div>
            </div>
            <div class="" :class="($mq === 'mobile' || $mq === 'tablet') ? 'col-md-12' : ''">
              <small class="title-header">
                {{ getTranslations('expression_48') }}
              </small>
              <div>
                {{ getUserObject('id', getOperatorObject('id', chat.lead_check.ticket.operator_id).user_id).name ? getUserObject('id', getOperatorObject('id', chat.lead_check.ticket.operator_id).user_id).name : '---' }}
              </div>
            </div>
            <div class="" :class="($mq === 'mobile' || $mq === 'tablet') ? 'col-md-12' : ''">
              <small class="title-header">
                {{ getTranslations('expression_67') }}
              </small>
              <div>
                {{ chat.lead_check.ticket.status.status ? chat.lead_check.ticket.status.status : '---' }}
              </div>
            </div>
            <div class="" :class="($mq === 'mobile' || $mq === 'tablet') ? 'col-md-12' : ''">
              <small class="title-header">
                {{ getTranslations('expression_66') }}
              </small>
              <div>
                {{ chat.lead_check.created ? chat.lead_check.created : '---' }}
              </div>
            </div>
            <div class="" :class="($mq === 'mobile' || $mq === 'tablet') ? 'col-md-12' : ''">
              <small class="title-header">
                {{ getTranslations('expression_15') }}
              </small>
              <div>
                {{ chat.lead_check.ticket.duration ? chat.lead_check.ticket.duration : '---' }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="tickets.ticket_step === 2">
        <div class="row animated--grow-in d-flex">
          <div class="row d-flex pt-4 pb-4 px-4">
            <div class="col-12 px-3 shadow-sm" :style="($mq === 'mobile' || $mq === 'tablet') ? 'min-height: 110px;' : ''">
              <div class="container_list" style="cursor: default!important;">
                <div class="avatar_content pl-1 pr-4">
                  <div style="width: 60px; height: 60px;"
                       class="pl-2 avatar">
                    <img style="min-width: 60px;
                                 min-height: 60px;
                                 z-index: 9;
                                 display: flex;
                                 border-radius: 50%;
                                 align-items: center;
                                 justify-content: center;"
                         class="avatar-img mt-1"
                         :src="chat.lead_check.avatar_url ? chat.lead_check.avatar_url : no_pic"/>
                    <span style="min-width: 60px;
                                 min-height: 60px;
                                 margin-left: -60px;
                                 z-index: 8;
                                 display: flex;
                                 border-radius: 50%;
                                 align-items: center;
                                 justify-content: center;
                                 background-color: #eee;"
                          class="avatar-img mt-1">
                      <i class="bx bx-loader-alt bx-spin" style="font-size: 2rem; color: #bfbfbf;"></i>
                    </span>
                  </div>
                </div>
                <div class="contact_area pr-4">
                  <div class="contact_title_area">
                    <div class="contact_title_line">
                      <div class="contact_title_line_area">
                        <span class="contact_title d-inline-block visible-true">
                          <span style="font-weight: 500; font-size: 1rem; color: #353535; letter-spacing: .02rem;">
                            {{ (chat.lead_check.name ? chat.lead_check.name : '---') | truncate(20) }}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="text_preview_content">
                    <div class="text_preview_area">
                      <span class="text_preview_zone">
                        <span class="contact_title d-inline-block visible-true">
                          <span style="font-family: 'Product Sans Light Regular';white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex-grow: 1; letter-spacing: .02rem; font-weight: 100; font-size: .8rem; color: #7c7c7c">
                            {{ chat.lead_check.phone_hidden ? chat.lead_check.phone_hidden : '---' }}
                          </span>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="row text_preview_content">
                    <div class="col-md-6" :class="($mq === 'mobile' || $mq === 'tablet') ? 'pb-1' : ''">
                      <div class="text_preview_area">
                        <span class="text_preview_zone">
                          <span class="contact_title d-inline-block visible-true">
                            <span style="display: flex; align-items: center; font-weight: 400; font-size: .7rem; color: #7c7c7c">
                              <i style="font-size: 1rem;"
                                 :class="getChannelObject('id', chat.lead_check.channel_id).type ? getChannelObject('id', chat.lead_check.channel_id).type.icon : 'bx bx-mobile'"
                                 class="mr-1"></i>
                              {{ getChannelObject('id', chat.lead_check.channel_id).name | truncate(20) }}
                            </span>
                          </span>
                        </span>
                      </div>
                    </div>
                    <div class="col-md-6" :class="($mq === 'mobile' || $mq === 'tablet') ? 'pt-0 pb-2 pl-2' : ''">
                      <div class="text_small_list">
                        <span>
                          <div class="text_preview_flag">
                            <span style="display: flex; align-items: center; font-weight: 400; font-size: .7rem; color: #7c7c7c">
                              <i class="bx bx-time mr-1"></i>
                              {{ chat.lead_check.created ? chat.lead_check.created : '---' }}
                            </span>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 px-3">
            <label class="mb-0 px-1">{{ getTranslations('expression_12') }}</label>
            <div class="input-group px-1 mb-2">
              <select v-if="getOperatorsArray('user_id', me.data.id).length > 0"
                      @change.prevent="walletCheck(); chat.new_ticket.operator_id = null"
                      v-model="chat.new_ticket.department_id"
                      class="input_forms form-control custom-select">
                <option :value="null">{{ getTranslations('expression_285') }}</option>
                <option v-for="department in getDepartmentsArray('channel_id', chat.lead_check.channel_id)"
                        :key="department.id"
                        :value="department.id"
                        v-if="isOperator(department.id)"
                        >
                  {{ department.name }}
                </option>
              </select>

              <select v-else
                      v-model="chat.new_ticket.department_id"
                      @change.prevent="chat.new_ticket.operator_id = null"
                      class="input_forms form-control custom-select">
                <option :value="null">{{ getTranslations('expression_285') }}</option>
                <option v-for="department in getDepartmentsArray('channel_id', chat.lead_check.channel_id)"
                        :key="department.id"
                        :value="department.id">
                  {{ department.name }}
                </option>
              </select>
            </div>
          </div>

          <div v-if="chat.new_ticket.department_id && getOperatorsArray('user_id', me.data.id).length === 0" class="col-md-12 px-3">
            <label class="mb-0 px-1">{{ getTranslations('expression_48') }} </label>
            <div class="input-group px-1 mb-3">
              <select v-model="chat.new_ticket.operator_id"
                      @change="walletCheckAdmin();"
                      class="input_forms form-control custom-select">
                <option :value="null">{{ getTranslations('expression_127') }}</option>
                <option v-for="operator in getOperatorsArray('department_id', chat.new_ticket.department_id)"
                        :key="operator.id"
                        :value="operator.id">
                  {{ getUserObject('id', operator.user_id).name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-3 py-2">
      <!-- checkWhatsappNumber(chat.lead_check.phone) -->
      <!-- :disabled="loading_lead_check" -->
      <button @click.prevent="newTicket"
              :disabled="loading_lead_check"
              v-if="(chat.new_ticket.department_id > 0 && chat.wallet_check.id >= 0)"
              type="button"
              class="btn btn-primary btn-sm rounded-0 cursor-default animated--grow-in px-3 pr-4">
        <i class="bx bx-xs mr-1 font-weight-bold" :class="loading_lead_check ? 'bx-loader bx-spin' : 'bx-check'"></i>
        {{ getTranslations('expression_157') }}
      </button>
      <span v-if="chat.new_ticket.department_id > 0 && chat.wallet_check.id < 0"
            style="cursor: not-allowed"
            class="shadow-sm animated--grow-in bg-light text-gray-600 py-2 px-3">
        <span class="">{{ getTranslations('expression_624') }}</span>
      </span>
    </div>
  </ModalDefault>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import ModalDefault from "../../components/general/ModalDefault";
import no_pic from "../../assets/img/no-pic-user.png"
import $ from "jquery";

export default {
  name: "ModalOpenTicket",
  components: {
    ModalDefault
  },
  computed: {
    ...mapState([]),
    ...mapGetters([])
  },
  data() {
    return {
      no_pic: no_pic,
      whatsapp_exists: false,
      error_when_verify_whatsapp: false,
      loading_lead_check: false,
    }
  },
  mounted() {
    $('#openTicketModal').on('hidden.bs.modal', () => {
      this.chat.lead_check = {}
      this.chat.wallet_check = {}
      this.chat.new_ticket = {
        department_id: null
      }
      this.tickets.ticket_step = 1
    })
  },
  watch: {
    // 'chat.new_ticket.department_id': function (){
    //   this.walletCheck()
    // }
  },
  methods: { 
    goLeads(){
      this.$router.push({name: 'Leads'})
    },
    // checkWhatsappNumber(chat.lead_check.phone);
    async checkWhatsappNumber(number) {
      this.error_when_verify_whatsapp = false;
      let channel = this.getChannelObject('id', this.chat.lead_check.channel_id);
      
      if(channel.type_key == 0) {
        if(number.length > 8) {
          this.loading_lead_check = true;

          await api.post('https://whatsapp.beelabs.com.br/chat/whatsappNumbers/instance-verify',
            { numbers:[ number ] },
            { headers: { 'apikey': 'instance-verify' } }
            ).then((response) => {
              this.error_when_verify_whatsapp = false;
              if(response.data[0].exists == false) {
                this.loading_lead_check = false;
                this.whatsapp_exists = false;
              } else {
                this.loading_lead_check = false;
                this.whatsapp_exists = true;
              };
              }).catch(error => {
                this.error_when_verify_whatsapp = true;
                this.$swal.fire({
                  title: `${this.getTranslations('expression_213')}`,
                  html: `${this.getTranslations('expression_214')}`,
                  icon: 'warning',
                  showCancelButton: false,
                  confirmButtonColor: 'btn-primary',
                  confirmButtonText: `Ok`
                  // confirmButtonText: `${this.getTranslations('expression_1289')}`
                  // cancelButtonText: this.getTranslations('expression_355')
                })
              })
              this.newTicket();
        }
      } else {
        this.newTicket();
      }
    },
    newTicket(){
      // ANTES
      // let channel = this.getChannelObject('id', this.chat.lead_check.channel_id);
      // if(channel.type_key != 0 || (this.whatsapp_exists && !this.error_when_verify_whatsapp)) {
      //   if (this.chat.new_ticket.department_id > 0 && this.getOperatorsArray('user_id', this.me.data.id).length > 0) {
      //     // SE FOR OPERADOR
      //     this.chat.new_ticket.operator_id = this.isOperator(this.chat.new_ticket.department_id)
      //     this.chat.new_ticket.channel_id = this.chat.lead_check.channel_id
      //     this.chat.new_ticket.lead_id = this.chat.lead_check.id
      //     const lead_id = this.chat.new_ticket.lead_id

      //     $('#openTicketModal').modal('hide')

      //     this.$store.dispatch('newTicket', this.chat.new_ticket)

      //     setTimeout(() => {
      //       if (this.$route.name === 'Lead') {
      //         this.$store.dispatch('getTickets', {
      //           lead_id: lead_id,
      //           per_page: 10
      //         })
      //       }
      //       if (this.$route.name === 'Chat') {
      //         if (this.chat.active_leads_book) {
      //           this.clearLeadsBook()
      //         }
      //         setTimeout(() => {
      //           const ticket = this.getChatTicketsFilter().find(chat => {
      //             return chat.lead_id = lead_id
      //           })
      //           if (ticket) {
      //             this.$root.$emit('openChat', ticket)
      //           }
      //         }, 600)
      //       }
      //     }, 200)
      //   } else {
      //     // SE FOR ADMIN
      //     if (this.chat.new_ticket.department_id > 0) {
      //       this.chat.new_ticket.channel_id = this.chat.lead_check.channel_id
      //       this.chat.new_ticket.lead_id = this.chat.lead_check.id
      //       const lead_id = this.chat.new_ticket.lead_id

      //       $('#openTicketModal').modal('hide')
      //       this.$store.dispatch('newTicket', this.chat.new_ticket)
      //       setTimeout(() => {
      //         this.$store.dispatch('getTickets', {
      //           lead_id,
      //           per_page: 10
      //         })
      //       }, 200)
      //     }
      //   } 
      // } else {
      //   if(this.error_when_verify_whatsapp) {
      //     this.$swal.fire({
      //       title: `${this.getTranslations('expression_213')}`,
      //       html: `${this.getTranslations('expression_214')}`,
      //       icon: 'warning',
      //       showCancelButton: false,
      //       confirmButtonColor: 'btn-primary',
      //       confirmButtonText: `Ok`
      //       // confirmButtonText: `${this.getTranslations('expression_1289')}`
      //       // cancelButtonText: this.getTranslations('expression_355')
      //     })
      //   } else {
      //     this.$swal.fire({
      //       title: `${this.getTranslations('expression_217')}`,
      //       text: `${this.getTranslations('expression_218')}`,
      //       // html: `Não foi possível `,
      //       icon: 'warning',
      //       showCancelButton: false,
      //       confirmButtonColor: 'btn-primary',
      //       confirmButtonText: `Ok`
      //       // confirmButtonText: `${this.getTranslations('expression_1289')}`
      //       // cancelButtonText: this.getTranslations('expression_355')
      //     })
      //   }
      // }

      //DEPOIS
      if (this.chat.new_ticket.department_id > 0 && this.getOperatorsArray('user_id', this.me.data.id).length > 0) {
        // SE FOR OPERADOR
        this.chat.new_ticket.operator_id = this.isOperator(this.chat.new_ticket.department_id)
        this.chat.new_ticket.channel_id = this.chat.lead_check.channel_id
        this.chat.new_ticket.lead_id = this.chat.lead_check.id
        const lead_id = this.chat.new_ticket.lead_id

        $('#openTicketModal').modal('hide')

        this.$store.dispatch('newTicket', this.chat.new_ticket)

        setTimeout(() => {
          if (this.$route.name === 'Lead') {
            this.$store.dispatch('getTickets', {
              lead_id: lead_id,
              per_page: 10
            })
          }
          if (this.$route.name === 'Chat') {
            if (this.chat.active_leads_book) {
              this.clearLeadsBook()
            }
            setTimeout(() => {
              const ticket = this.getChatTicketsFilter().find(chat => {
                return chat.lead_id = lead_id
              })
              if (ticket) {
                this.$root.$emit('openChat', ticket)
              }
            }, 600)
          }
        }, 200)
      } else {
        // SE FOR ADMIN
        if (this.chat.new_ticket.department_id > 0) {
          this.chat.new_ticket.channel_id = this.chat.lead_check.channel_id
          this.chat.new_ticket.lead_id = this.chat.lead_check.id
          const lead_id = this.chat.new_ticket.lead_id

          $('#openTicketModal').modal('hide')
          this.$store.dispatch('newTicket', this.chat.new_ticket)
          setTimeout(() => {
            this.$store.dispatch('getTickets', {
              lead_id,
              per_page: 10
            })
          }, 200)
        }
      } 
    },
    walletCheck(){
      if (this.chat.new_ticket.department_id > 0){
        // Verificar se é admin
        this.chat.new_ticket.operator_id = this.isOperator(this.chat.new_ticket.department_id)
        this.chat.new_ticket.channel_id = this.chat.lead_check.channel_id
        this.chat.new_ticket.lead_id = this.chat.lead_check.id
        if(this.chat.new_ticket.department_id > 0) {
          this.$store.dispatch('getWalletCheck', this.chat.new_ticket)
        }
      }
    },
    // TODO: Melhorar funcionalidade
    walletCheckAdmin(){
      if (this.me.data.role_key > 0 && this.chat.new_ticket.department_id > 0){
        // Verificar se é admin
        this.chat.new_ticket.operator_id = this.isOperator(this.chat.new_ticket.department_id) ? this.isOperator(this.chat.new_ticket.department_id) : this.xeroxHelper(this.chat.new_ticket.operator_id)
        this.chat.new_ticket.channel_id = this.chat.lead_check.channel_id
        this.chat.new_ticket.lead_id = this.chat.lead_check.id
        if(this.chat.new_ticket.department_id > 0 && this.chat.new_ticket.operator_id) {
          this.$store.dispatch('getWalletCheck', this.chat.new_ticket)
        }
      }
    },
    isOperator(department_id) {
      if (department_id === null) {
        department_id = this.getChannelObject('id', this.tickets.ticket.channel_id).parameter.department_id
      }
      let operator = this.operators.data.find(operator => {
        return operator.department_id === department_id && operator.user_id === this.me.data.id;
      });
      if (operator !== undefined) {
        return operator.id
      } else {
        return null
      }
    },
    clearLeadsBook(){
      this.chat.active_leads_book = !this.chat.active_leads_book
      this.$store.dispatch('getLeads', {
        status_key: 1
      })
    },
  }
}
</script>

<style src="../../assets/css/pages/chat.css" scoped/>

<style scoped>

</style>
